import { getCalendarLabelByMode } from '@modules/common/components/DateRangePicker/CalendarPicker/helpers';
import {
  formatDateRange,
  getDateRange,
} from '@modules/common/components/DateRangePicker/helpers';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { useGetFeedDuration } from '@modules/feed/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { Grid, Stack, Typography } from '@mui/material';

export const FeedDurationDefinitionInfo = () => {
  const duration = useGetFeedDuration();
  const isDashboardDurationApplied = useFeedStore(
    ({ visual }) => !!visual.dashboardFilters?.duration,
  );
  const defaultTimeRange = useGetDefaultTenantTimeRange();

  const [from, to] = getDateRange(duration ?? defaultTimeRange);

  const primaryLabel = getCalendarLabelByMode([from, to], duration, '--');
  const durationDateRangeString = from && to ? formatDateRange(from, to) : '--';
  const secondaryLabel =
    duration.type === 'last' ? durationDateRangeString : null;

  return (
    <>
      <Grid item xs={3}>
        <Typography variant="caption" color="inherit" display="block">
          Duration:
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Stack>
          <Typography
            variant="caption"
            color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
            display="block"
          >
            {primaryLabel}
          </Typography>
          {secondaryLabel && (
            <Typography
              variant="caption"
              color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
              display="block"
            >
              {secondaryLabel}
            </Typography>
          )}
        </Stack>
      </Grid>
    </>
  );
};
